<mat-tab-group id="home" class="tab-default content-with-float-btn" mat-align-tabs="center"
  [(selectedIndex)]="selectedTabIndex" (selectedIndexChange)="onTabChange($event)">
  <!-- PROPERTIES CARDS -->
  <mat-tab *ngIf="canSeePropertyCardList">
    <ng-template mat-tab-label>
      <mat-icon class="mr-1" [appTooltip]="'Grille'">grid_view</mat-icon>
    </ng-template>
    <ng-template matTabContent>
      <app-property-card-list></app-property-card-list>
    </ng-template>
  </mat-tab>
  <!-- MAP -->
  <mat-tab *ngIf="canSeePropertyMap">
    <ng-template mat-tab-label>
      <mat-icon class="mr-1" [appTooltip]="'Carte'">map</mat-icon>
    </ng-template>
    <ng-template matTabContent>
      <app-map-wrapper [hasSatelliteView]="true" [hasPlanView]="true" [hasEventParcelles]="false" [initMapCoord]=""
        [searchEnabled]="searchEnabled"></app-map-wrapper>
    </ng-template>
  </mat-tab>
  <!-- PROPERTIES LIST -->
  <mat-tab *ngIf="canSeePropertyList">
    <ng-template mat-tab-label>
      <mat-icon class="mr-1" [appTooltip]="'Liste'">list</mat-icon>
    </ng-template>
    <ng-template matTabContent>
      <div class="btn-share m-2">
        <button mat-mini-fab color="primary" class="ml-2" appTooltip="Partager les biens" (click)="addShares()"
          [disabled]="selectedProps.length === 0">
          <mat-icon>share</mat-icon>
        </button>
      </div>
      <app-filters-property-list (filterData)="filterData = $event" [list]="newlist"
        [defaultChildrenType]="PropertyChildrenTypeFilter.AUTO">
      </app-filters-property-list>
      <app-property-list [filterData]="filterData" [lightColumns]="lightColumns" [reload]="reload"
        [defaultChildrenType]="PropertyChildrenTypeFilter.AUTO" (newList)="newlist = $event"
        (selectedProps)="selectedProps = $event" [selectionMustBeCertified]="true">
      </app-property-list>
    </ng-template>
  </mat-tab>
  <!-- PROPERTIES ARCHIVE-->
  <mat-tab *ngIf="canSeePropertyArchives">
    <ng-template mat-tab-label>
      <mat-icon class="mr-1" [appTooltip]="'Archives'">archive</mat-icon>
    </ng-template>
    <ng-template matTabContent>
      <app-filters-property-list (filterData)="filterData = $event" [list]="newlist"
        [defaultChildrenType]="PropertyChildrenTypeFilter.AUTO" [showPropertyFilter]="false">
      </app-filters-property-list>
      <app-property-list [filterData]="filterData" [lightColumns]="lightColumns" [reload]="reload"
        [defaultChildrenType]="PropertyChildrenTypeFilter.AUTO" (newList)="newlist = $event" [archiveMode]="true"
        [selectionEnabled]="false">
      </app-property-list>
    </ng-template>
  </mat-tab>
</mat-tab-group>